import React from 'react';
export function HowItWorks() {
  return <section className="py-12 md:py-16 bg-[#0a0e1a]" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-10" data-id="element-104">
          Cómo funciona en 3 pasos simples
        </h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-105">
          {[{
          step: '01',
          title: 'Identifica',
          desc: 'Usas la Matriz para descubrir qué tipo de creador es tu hijo.'
        }, {
          step: '02',
          title: 'Configura',
          desc: 'Sigues la guía visual para instalar el laboratorio de creación.'
        }, {
          step: '03',
          title: 'Crea',
          desc: "Dedican 30 minutos juntos a aplicar la primera 'Mecánica de Poder' en su juego."
        }].map((item, idx) => <div key={idx} className="relative group" data-id="element-106">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#00d4aa] to-[#f59e0b] rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-500" data-id="element-107"></div>
              <div className="relative bg-[#111827] p-8 rounded-2xl h-full border border-gray-800" data-id="element-108">
                <span className="text-6xl font-black text-gray-800 absolute top-4 right-4 select-none opacity-50" data-id="element-109">
                  {item.step}
                </span>
                <h3 className="text-2xl font-bold text-white mb-4 relative z-10" data-id="element-110">
                  {item.title}
                </h3>
                <p className="text-gray-400 relative z-10" data-id="element-111">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}